import React from 'react';
import IpaffsModalConsolidatedView from './IpaffsModalConsolidatedView';
import IpaffsModalConsolidatedViewReadOnly from './IpaffsModalConsolidatedViewReadOnly';

const IpaffsModalTabConsolidatedView = ({ readOnly = false, data = [] }) => {
  return <>{!readOnly ? <IpaffsModalConsolidatedView /> : <IpaffsModalConsolidatedViewReadOnly data={data} />}</>;
};

export default IpaffsModalTabConsolidatedView;
